module.exports = __webpack_public_path__ + "icon-tb.c2f63260e3c4ea25e402.png";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/src/assets/img/icon-tb.png
// module id = ../../../../../src/assets/img/icon-tb.png
// module chunks = 2